import { render } from "./DeathDetail.vue?vue&type=template&id=fbeba7d2&scoped=true"
import script from "./DeathDetail.vue?vue&type=script&lang=js"
export * from "./DeathDetail.vue?vue&type=script&lang=js"

import "./DeathDetail.vue?vue&type=style&index=0&id=fbeba7d2&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbeba7d2"]])

export default __exports__